window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    $(window).on('resize', function () {
      $('html').css(
        '--header-height',
        $('.site-header').children().outerHeight(),
      );
    });

    $('html').css(
      '--header-height',
      $('.site-header').children().outerHeight(),
    );

    $('a.open-menu').on('click', function (e) {
      e.preventDefault();

      if ($('.mobile-mega-menu').hasClass('open')) {
        $('.submenu').removeClass('open');
      }

      $(this).toggleClass('open');
      $('html').toggleClass('overflow-hidden');
      $('.mobile-mega-menu').toggleClass('open');
    });

    $('.menu-item.desktop[data-opens]').on('mouseenter', function (e) {
      $('.submenu-backdrop').toggleClass('active', true);
    });

    $('.menu-item.desktop[data-opens]').on('mouseleave', function (e) {
      $('.submenu-backdrop').toggleClass('active', false);
    });

    function handleMouseEnterAndLeave(type) {
      let $this = $(this);
      let $target = $(`.submenu.desktop[data-handle="${$this.data('opens')}`);

      if (!$target.length) {
        console.error(`No submenu found for handle ${$this.data('opens')}`);
        return;
      }

      $(this).toggleClass('hovered', type === 'mouseenter' ? true : false);
      $target.toggleClass(
        'open hover-open',
        type === 'mouseenter' ? true : false,
      );
    }

    $('.menu-item.desktop[data-opens]').on(
      'mouseenter mouseleave',
      function (e) {
        handleMouseEnterAndLeave.call(this, e.type);
      },
    );

    $('.menu-item:not(.desktop)[data-opens]').on('click', function (e) {
      e.preventDefault();

      let $this = $(this);
      let $target = $(`.submenu[data-handle="${$this.data('opens')}`);

      if (!$target.length) {
        console.error(`No submenu found for handle ${$this.data('opens')}`);
        return;
      }

      $(this).toggleClass('open');
      $target.toggleClass('open');
    });

    $('.submenu .back-cta').on('click', function (e) {
      e.preventDefault();
      $(this).closest('.submenu').removeClass('open');
      $(
        `.menu-item[data-opens="${$(this).closest('.submenu').data('handle')}"]`,
      ).removeClass('open');
    });
  });
});
